export enum EClassification {
  PRODUCTION = "PRODUCTION",
  TEST = "TEST",
}
